import styled from "styled-components";
import { FlexMixin, FontMixin } from "../../../../../../../../styles/common/mixins/helpers.styled.js";
export const PersonCounter = styled.div.withConfig({
    displayName: "styled__PersonCounter",
    componentId: "sc-dd53f702-0"
})`
	${FlexMixin({
    align: 'center',
    justify: 'end'
})}

	input {
		width: ${({ $hasAgeLabel  })=>$hasAgeLabel ? '100px' : '70px'};
		height: 52px;
	}
	.input-without-label {
		padding: 0 16px 0 3px;
		min-height: 38px;
	}
	&:not(:last-child) {
		border-bottom: 1px solid ${({ theme  })=>theme.colors.grays.light};
	}
`;
export const Label = styled.p.withConfig({
    displayName: "styled__Label",
    componentId: "sc-dd53f702-1"
})`
	${FontMixin({
    size: 'base',
    weight: 'light',
    height: 'small'
})}
	color: ${({ theme  })=>theme.colors.black.base};
	margin-right: auto;
	text-transform: capitalize;
`;

//# sourceMappingURL=styled.js.map